import React, { useState, useEffect } from "react";

import {
  getCustomProjectsNetsuite,
} from "../../actions/admin";

import { useSelector, useDispatch } from "react-redux";
import fuzzysort from "fuzzysort";
import styled from "styled-components";

import NoImage from "../../assets/img/unavailable.svg";
import EditIcon from "../../assets/img/Account/edit-icon.svg";
import DeleteIcon from "../../assets/img/Account/delete-icon.svg";
import { deleteSalesPrices, getSalesPrices, updateSalesPrices } from "../../actions/products";

const StyledAddButton = styled.button`
  ${props => props.brand && `
    color: ${props.brand.colors.theme} !important;
  `}
`;

const StyledSearchInput = styled.input`
  ${props => props.brand && `
    &:focus {
      border-bottom: 1px solid ${props.brand.colors.theme} !important;
    }
  `}
`;

const StyledActionButtons = styled.div`
  ${props => props.brand && `
    .btn-link {
      color: ${props.brand.colors.theme} !important;
    }
  `}
`;

const initialState = {
  price: "",
  id: "",
};

const PageSize = 10;

const ProductSale = ({ mainCompany }) => {
  const admin = useSelector((state) => state.admin);
  const productsData = useSelector((state) => state.products);
  const account = useSelector((state) => state.account);
  const { brand } = account;
  
  const [search, setSearch] = useState("");
  const [filterCustomPrice, setFilterCustomPrice] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [actionType, setActionType] = useState("");
  const [actionLoading, setActionLoading] = useState(false);
  const [formData, setFormData] = useState(initialState);
  const [errorMsg, setErrorMsg] = useState("");
  const [showError, setShowError] = useState(false);
  const [alertType, setAlertType] = useState("error");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentItems, setCurrentItems] = useState([]);
  const [endIndex, setEndIndex] = useState(0)
  const dispatch = useDispatch();

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSearchChange = (e) => setSearch(e.target.value);

  const handleSubmit = () => {
    setActionLoading(true);
    dispatch(updateSalesPrices(formData, brand.region));
  };

  const handleDelete = (id) => {
    if (window.confirm("Remove custom price for this product?") == true) {
      setFormData({ ...formData, id });
      setActionType("delete");
      setActionLoading(true);
      let payload = { id };
      dispatch(deleteSalesPrices(payload, brand.region));
    }
  };

  const handleAlert = (msg, type) => {
    setErrorMsg(msg);
    setShowError(true);
    setAlertType(type);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const formatPrice = (price) => {
    var n = parseFloat(price).toFixed(2);
    return n;
  };

  const getIntegerInStringArray = (string) => {
    return string.match(/[0-9\.,]+/g);
  };

  const roundToTwo = (num) => {
    return +(Math.round(num + "e+3") + "e-3");
  };

  const getPricePerUnit = (bottleSize, price) => {
    if (!bottleSize) {
      return "";
    }

    const sizeInString = getIntegerInStringArray(bottleSize);

    if (!sizeInString || sizeInString.length !== 1 || price === 0) {
      return "";
    }

    const ppu = roundToTwo(price / sizeInString);

    return `$ ${ppu}`;
  };

  useEffect(() => {
    if (admin.customProductNetsuite && productsData.adminProducts) {
      let products, searchResult, changeTimer;
      changeTimer = setTimeout(() => {
        products = productsData.adminProducts.map((prod, key) => {
          let customIndex = productsData?.salesPrice.findIndex(
            (salePrice) => 
            salePrice.id === prod.id.toString()
          );
          if (customIndex !== -1) {
            return {
              ...prod,
              id: prod.id.toString(),
              salePrice: productsData?.salesPrice[customIndex].price,
            };
          }

          return { ...prod, id: prod.id.toString() };
        });

        if (filterCustomPrice) {
          products = products.filter((prod) => prod.salePrice);
        }

        searchResult = fuzzysort.go(search, products, {
          keys: ["id", "name", "ndc", "productNumber"],
          all: true,
        });

        searchResult = searchResult.sort(function (a, b) {
          return a.obj.name > b.obj.name
            ? 1
            : a.obj.name === b.obj.name
              ? 0
              : -1;
        });

        search ? setCurrentItems(searchResult) : setFilteredProducts(searchResult);
      }, 1000);

      return () => {
        clearTimeout(changeTimer);
      };
    }
  }, [search, admin, filterCustomPrice, productsData]);

  useEffect(() => {
    if (brand) {
      dispatch(getSalesPrices(brand.region));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brand]);

  useEffect(() => {
    if (actionLoading && productsData.upsertError === "NO Upsert Error") {
      handleAlert("Adding/updating sales price successfully!", "success");
    }
    if (productsData.upsertError === "Error") {
      handleAlert(
        "Error adding/updating sales price. Try again later!",
        "error"
      );
    }
    if (productsData.removeCustomError === "No Error") {
        handleAlert("Deleted sales price successfully!", "success");
      }
    if (productsData.removeCustomError === "Error") {
      handleAlert("Error deleting sales price. Try again later!", "error");
    }
    setFormData(initialState);
    setActionLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsData]);

  useEffect(() => {
    mainCompany && dispatch(getCustomProjectsNetsuite(mainCompany.username, brand.region));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainCompany]);

  const totalPages = Math.ceil(filteredProducts.length / PageSize);

  useEffect(() => {
    const startIndex = (currentPage - 1) * PageSize;
    setEndIndex(startIndex + PageSize);
    setCurrentItems(filteredProducts.slice(startIndex, endIndex));
  }, [currentPage, filteredProducts, endIndex])

  return (
    <>
      <div className="card">
        <div className="d-flex align-items-center justify-content-between mt-4 mb-4 header">
          <h2 className="m-0">All Products</h2>
          <div className="w-75 filter-container d-flex align-items-center">
            <div className="search-container input-group">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">
                  Search
                </span>
              </div>
              <StyledSearchInput
                brand={brand}
                className="form-control"
                type="text"
                name="search"
                value={search}
                placeholder="id/name/ndc/product number"
                onChange={handleSearchChange}
                autoComplete="off"
              />
            </div>
            <div className="custom-control custom-switch no-wrap ml-5">
              <input
                type="checkbox"
                className="custom-control-input"
                id="customSwitch2"
                checked={filterCustomPrice}
                onChange={(e) => setFilterCustomPrice(e.target.checked)}
              />
              <label className="custom-control-label" htmlFor="customSwitch2">
                Filter with sales price
              </label>
            </div>
          </div>
        </div>
        <div className="table-container custom">
          <table className="table table-hover">
            <thead className="thead-dark">
              <tr>
                <th scope="col"></th>
                <th scope="col">
                  Item # <br /> NDC
                </th>
                <th scope="col">Name</th>
                <th scope="col">Last Purchase Price</th>
                <th scope="col">Floor Price</th>
                <th scope="col">
                  Price <br /> PPU
                </th>
                <th scope="col">Sales Price</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((product, index) => (
                <tr key={`product${index}`}>
                  <td>
                    <img
                      width={40}
                      src={
                        product.obj.imageUrl ? product.obj.imageUrl : NoImage
                      }
                      alt=""
                    />
                  </td>
                  <td>
                    {product.obj.productNumber} <br /> {product.obj.ndc}
                  </td>
                  <td>{product.obj.name}</td>
                  <td>
                    {(product.obj?.lastPurchasePrice &&
                      product.obj?.lastPurchasePrice !== "0") &&
                      `$${formatPrice(product.obj?.lastPurchasePrice)}`}
                  </td>
                  <td>
                    {product.obj?.lastPurchasePrice &&
                      product.obj?.lastPurchasePrice !== "0"
                      ? `$${formatPrice(
                        parseFloat(product.obj?.lastPurchasePrice) * 1.15
                      )}`
                      : null}
                  </td>
                  <td>
                    ${formatPrice(product.obj.price)} <br />
                    {getPricePerUnit(product.obj.bottleSize, product.obj.price)}
                  </td>
                  <td>
                    {product.obj.id === formData.id &&
                      actionType === "edit" ? (
                      <>
                        <input
                          className="form-control mb-2"
                          type="text"
                          name="price"
                          value={formData.price}
                          placeholder=""
                          onChange={handleChange}
                          autoComplete="off"
                          disabled={actionLoading}
                        />
                        <StyledActionButtons
                          brand={brand}
                          className="d-flex justify-content-between align-items-center">
                          <button
                            className="btn btn-link"
                            onClick={() => handleSubmit()}
                            disabled={actionLoading}
                          >
                            {actionLoading ? (
                              <div
                                className="spinner-border text-primary spinner-border-sm"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            ) : (
                              "Save"
                            )}
                          </button>
                          <button
                            className="btn btn-link ml-2"
                            onClick={() => {
                              setActionType("");
                              setFormData({
                                ...formData,
                                id: "",
                                price: "",
                              });
                            }}
                            disabled={actionLoading}
                          >
                            Cancel
                          </button>
                        </StyledActionButtons>
                      </>
                    ) : (
                      <div className="d-flex align-items-center justify-content-between">
                        {product.obj.salePrice &&
                          `$${product.obj.salePrice}`}
                        <div className="d-flex align-items-center ml-2">
                          <StyledAddButton
                            brand={brand}
                            className="btn btn-link "
                            onClick={() => {
                              setActionType("edit");
                              setFormData({
                                ...formData,
                                id: product.obj.id,
                                price: product.obj.salePrice || "0",
                              });
                            }}
                            disabled={actionLoading}
                          >
                            {product.obj.salePrice ? (
                              <img
                                className="edit-icon"
                                src={EditIcon}
                                alt=""
                              />
                            ) : (
                              "Add"
                            )}
                          </StyledAddButton>
                          {product.obj.salePrice && (
                            <button
                              className="btn btn-link ml-2"
                              onClick={() => handleDelete(product.obj.id)}
                              disabled={actionLoading}
                            >
                              {actionLoading &&
                                actionType === "delete" &&
                                product.obj.id === formData.id ? (
                                <div
                                  className="spinner-border text-danger spinner-border-sm ml-2"
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                              ) : (
                                <img
                                  className="delete-icon"
                                  src={DeleteIcon}
                                  alt=""
                                />
                              )}
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div>
            {!search &&
              <div>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{ marginRight: '10px' }}
                >
                  Previous
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={endIndex >= filteredProducts.length}
                  style={{ marginLeft: '10px' }}
                >
                  Next
                </button>
              </div>
            }
          </div>
        </div>
      </div>
      <div
        id="toast"
        className={
          "toast alert " +
          (alertType === "error" ? "alert-danger " : "alert-success ") +
          (showError ? "show" : "")
        }
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        data-delay="2000"
        style={{ position: "fixed", bottom: "1rem", right: "1rem" }}
      >
        {errorMsg}
      </div>
    </>
  );
};

export default ProductSale;
